import { ThemeProvider } from "styled-components";
import GlobalStyle from "./globalStyles";
import { DarkTheme, lightTheme } from "./components/Themes";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import LoadingPage from './components/LoadingPage';

// Components
import Main from "./components/Main";
import AboutPage from "./components/AboutPage";
import FeatsPage from "./components/FeatsPage";
import ProjectPage from "./components/ProjectPage";
import MySkillsPage from "./components/MySkillsPage";
import { AnimatePresence } from "framer-motion";
import Resume from "./subComponents/Resume";
import SoundBar from "./subComponents/SoundBar";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Main />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/feats" element={<FeatsPage />} />
        <Route path="/projects" element={<ProjectPage />} />
        <Route path="/skills" element={<MySkillsPage />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  const [loading, setLoading] = useState(false);
  const [theme, setTheme] = useState('light');
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 400);
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <>
      {loading && <LoadingPage theme={theme} />}
      <GlobalStyle />
      <ThemeProvider theme={theme === "light" ? lightTheme : DarkTheme}>
        <Resume/>
        <SoundBar/>
        <AnimatedRoutes />
      </ThemeProvider>
    </>
  );
}

export default App;
